import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ShopCard from "@/components/ShopCard";
import BundleBanner from "@/components/BundleBanner";

// Two product cards, then the bundle banner below.
const CARD_ORDER = [
  "soft-life-reset-workbook",
  "soft-financial-calendar", // Soft Life Reset Planner
];
const BUNDLE_ID = "soft-life-bundle";

const Shop = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const byId = Object.fromEntries(products.map((p) => [p.id, p]));
  const cards = CARD_ORDER.map((id) => byId[id]).filter(Boolean);
  const bundle = byId[BUNDLE_ID];

  return (
    <div data-testid="shop-page" className="pt-32 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C6A769] mb-4">The Collection</p>
          <h1 className="font-serif-display text-5xl sm:text-6xl text-[#4A3F35]">Shop All</h1>
          <p className="mt-5 text-[#8A7D71] max-w-md mx-auto">
            Digital tools designed to reset your mindset and design your soft, abundant life.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-8">
          {cards.map((p, i) => (
            <ShopCard key={p.id} product={p} index={i} />
          ))}
        </div>

        <BundleBanner product={bundle} />

        <p
          data-testid="shop-footer-caption"
          className="text-center text-[13px] text-[#9C8F82] mt-14"
        >
          All digital products. Instant delivery.
        </p>
      </div>
    </div>
  );
};

export default Shop;
